<div class="-mt-[30px] pb-[60px]">
  <ng-container *ngIf="!initialized; else loaded">
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
  </ng-container>

  <ng-template #loaded>
    <ng-container *ngIf="listOfTask?.length; else empty">
      <div
        *ngFor="let task of listOfTask"
        class="v4-layout-list-item cursor-pointer"
        [ngClass]="{
          'opacity-50': task.retried
        }"
        (click)="onClickTask(task)"
      >
        <!-- line-1 -->
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <div
              class="status leading-[20px] mr-[12px] px-[8px] text-[12px] text-white rounded-[4px]"
              [ngClass]="{
                'bg-[#ff8846]': task.sync_status === TaskStatus.PartiallyFailed,
                'bg-[#ff391e]': task.sync_status === TaskStatus.Failed,
                'bg-[#2c80f0]': task.sync_status === TaskStatus.InProgress,
                'bg-[#83bf6e]': task.sync_status === TaskStatus.Success
              }"
            >
              {{ StatusMap[task.sync_status] | translate }}
            </div>

            <div class="ellipsis">{{ task.title_str }}</div>
          </div>

          <a
            *ngIf="task.sync_status === TaskStatus.Failed || task.sync_status === TaskStatus.PartiallyFailed"
            nz-button
            nzType="link"
            class="font-medium"
            [ngClass]="{
              'text-[#8d959f]': task.retried
            }"
            [nzLoading]="task.loading"
            (click)="$event.stopPropagation(); onClickRetry(task)"
          >
            {{ (task.retried ? "word.retried" : "word.retry") | translate }}
          </a>
        </div>

        <!-- line-2 -->
        <div class="flex flex-row items-center mt-[8px] cursor-pointer">
          <div class="text-[14px] text-[#34383c]" [innerHtml]="task.format_str | html">
            <!-- {{ task.format_str }} -->
          </div>
        </div>

        <!-- line-3 -->
        <div class="flex flex-row items-center mt-[8px]">
          <div class="text-[13px] text-[#8d959f]">
            {{ task.create_time | dateformat: ["YMD", "hms"] }} {{ task.reservation_code }}
          </div>
        </div>

        <!-- line-4 -->
        <div *ngIf="task.failed_reason" class="flex flex-row items-center mt-[8px]">
          <div class="text-[13px] text-red-500">Reason: {{ task.failed_reason }}</div>
        </div>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="v4-layout-empty my-[100px]">
        <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-title">{{ "word.no_data" | translate }}</div>
        </div>
      </div>
    </ng-template>

    <div *ngIf="listOfTask?.length" class="text-right mt-6">
      <nz-pagination
        [(nzPageIndex)]="page"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        (nzPageIndexChange)="onPageChange()"
      ></nz-pagination>
    </div>
  </ng-template>
</div>
